//Global Routes
import React from "react";
import { BrowserRouter as Router,Routes, Route, Navigate } from "react-router-dom";
import Header from "./pages/common/header/Header";
import Footer from "./pages/common/footer/Footer";
import DashboardComponent from "./pages/dashboard/dashboard-component";
import HomeComponent from "./pages/home";
import AdminComponent from "./pages/admin";
import VendorComponent from "./pages/vendor";
import FarmerMarkerComponent from "./pages/manage/farmerMarket";
import UsersComponent from "./pages/manage/users";
import AuditLogsComponent from "./pages/manage/auditLogs";
import CoordinatesComponent from "./pages/manage/coordinates";
import UserRegistration from "./pages/user/signup/signup-component";
import Mystore from "./pages/mystore/mystore";
import GreenBanner from "./pages/home/GreenBanner";
import BlueBanner from "./pages/home/BlueBanner";
import YellowBanner from "./pages/home/YellowBanner";
import CsaLandingPage from "./pages/csa/csa-landing-component";
import CSASignupWrapper from "./pages/csa/signup/csa-signup-wrapper";
import PartialSignup from "./pages/manage/partialSignup";
import ClientAgreement from "./pages/csa/signup/client-agreement"
import PaymentsComponent from "./pages/manage/Payments";
import CSASignupStatusTab from "./pages/manage/csaSignupStatusTab";
import HeaderComponent from "./pages/home/HeaderComponent";

export default function RouterComponent() {
  return (
    <Router>
        {/* <GreenBanner /> 
        <YellowBanner />
        <BlueBanner />
        <Header /> */}
        <HeaderComponent />
        <Routes>
          <Route path="/" element={<HomeComponent />} />
          <Route path="dtafinder" element={<HomeComponent />} />
          <Route path="CSA" element={<Navigate to="/dtafinder/csa-landing" replace />} />
          <Route path="dtafinder/csa-landing" element={<CsaLandingPage />}/>
          <Route path="dtafinder/csa-signup" element={<CSASignupWrapper />} />
          <Route exact path="dtahip" element={<DashboardComponent />} />
          <Route path="dtahip/registration" element={<UserRegistration mode={"add"}/>}/>
          <Route path="dtahip/vendors/:vdrTyp" element={<Mystore allowedRoles={["ADMIN","HIPCRD"]}/>}/>
          <Route path="dtahip/mystore/:vdrTyp" element={<Mystore allowedRoles= {["HIPVDR", "VENDOR" ,"CSAVDR","SUBVDR"]}/>}/>
          <Route path="dtahip/admin-dashboard" element={<AdminComponent allowedRoles={["ADMIN", "HIPCRD"]}/>}/>
          <Route path="dtahip/manage-vendors" element={<VendorComponent allowedRoles={["ADMIN", "HIPCRD"]} />}/>
          <Route path="dtahip/manage-users" element={<UsersComponent allowedRoles={["ADMIN"]}/>}/>
          <Route path="dtahip/manage-farmer-markets" element={<FarmerMarkerComponent allowedRoles={["ADMIN"]}/>}/>
          <Route path="dtahip/manage-address" element={<CoordinatesComponent allowedRoles={["ADMIN"]}/>}/>
          <Route path="dtafinder/csa-signup/:agreementId/:clientId/:vendorId" element={<CSASignupWrapper allowedRoles={["ADMIN"]} />} />
          <Route path="dtafinder/csa-signup/:vendorId/:vendorNam" element={<CSASignupWrapper />} />
          {/* <Route path="dtahip/csa-signup-status" element={<CsaSignupStatus  allowedRoles={["ADMIN"]} />} /> */}
          <Route path="dtahip/csa-signup-status" element={<CSASignupStatusTab  allowedRoles={["ADMIN"]} />} />
          <Route path="dtahip/partial-signup" element={<PartialSignup allowedRoles={["ADMIN"]} />} />
          <Route path="dtahip/audit-logs" element={<AuditLogsComponent allowedRoles={["ADMIN"]}/>}/>
          <Route path="dtahip/manage-payments" element={<PaymentsComponent allowedRoles={["ADMIN"]} />} />           
          <Route path="dtafinder/client-agreement" element={<ClientAgreement />} />
          <Route path="*" element={<Navigate replace to="/dtahip" />}  />
        </Routes>
        <Footer />
    </Router>
  );
}
